import PortfolioCard from './PortfolioCard';
import PortfolioCards from './PortfolioCards';

export default PortfolioCards;
export {
  PortfolioCard,
}



// WEBPACK FOOTER //
// ./src/components/admin/Website/Portfolio/index.js